import { makeType, actionCreator } from "../../Utils/generateActionCreator";
import { API } from "aws-amplify";
import { toast } from "react-toastify";

const actionType = makeType("ADVISER");

export const VALIDATE = actionType("VALIDATE");
export const ERR_VALIDATE = actionType("ERR_VALIDATE");

export const REGISTER = actionType("REGISTER");
export const ERR_REGISTER = actionType("ERR_REGISTER");

export const ADD_ADVISERS = actionType('ADD_ADVISERS');

export const LOADING = actionType("LOADING");
export const CLEAN = actionType("CLEAN");

export const validateAdviser = actionCreator(VALIDATE, "permit");
export const registerAdviser = actionCreator(REGISTER, "register");

export const errValidateAdviser = actionCreator(ERR_VALIDATE, "error_permit");
export const errRegisterAdviser = actionCreator(ERR_REGISTER, "error_register");

export const addAdvisers = actionCreator(ADD_ADVISERS, 'listAdvisers');

export const loading = actionCreator(LOADING, "loading");

export const cleanAdviser = actionCreator(CLEAN);




export const validateAdviserRegister = async (dispatch) => {
  dispatch(loading(true));
  try {
    const response = await API.post("api-rentas", "/adviser-validate");
    if (response.success) dispatch(validateAdviser(true));
    else dispatch(errValidateAdviser(true));
  } catch(e) {
    console.log('error /adviser-validate', e);
  }
  dispatch(loading(false));
};

export const registerAdviserInDb = (dispatch) => async (request) => {
  dispatch(loading(true));
  const response = await API.post("api-rentas", "/adviser-register", request);
  if (response.success) dispatch(registerAdviser(true));
  else {
    dispatch(errRegisterAdviser(true));
    toast.error(response.error, {
        position: toast.POSITION.TOP_CENTER,
        className: "toast-modal",
      });
  }

  dispatch(loading(false));
};

export const getAdvisers = async (dispatch) => {
  const response = await API.post('api-rentas', '/list-advisers');

  let tempResponse = response.data;
  // for (let i = 0; i < tempResponse.length; i++) {
  //   tempResponse[i].lastName = encryptEstandar(tempResponse[i].lastName || "");
  //   tempResponse[i].name = encryptEstandar(tempResponse[i].name  || "");
  //   tempResponse[i].numDocumento = encryptEstandar(String(tempResponse[i].numDocumento) || "");
  //   tempResponse[i].email = encryptEstandar(tempResponse[i].email  || "");
  // }
  
  if (response.status) dispatch(addAdvisers(tempResponse));
};
